import { ThemeTypeThemesList } from '@/components/theme-types/ThemeTypeThemesList';
import { useThemeTypeContext } from '@/pages/theme-types/useThemeTypeContext';
import { Loading } from '@startupquickstart/frontend';
import { useParams } from 'react-router-dom';

export function ThemeTypeThemesTab() {
  const { id } = useParams<{ id: string }>();
  const { isLoading } = useThemeTypeContext();

  if (isLoading || !id) {
    return (
      <div className="flex justify-center py-12">
        <Loading />
      </div>
    );
  }

  return <ThemeTypeThemesList themeTypeId={id} className="p-0" />;
}
